<template>
  <div class="wrap">

    <h1>{{ t }}</h1>
    <p>{{ p1 }}</p>
    <img class="app" src="../../../../assets/images/simustock/app.png" alt="">
    <p>{{ p2 }}</p>
    <img class="search" src="../../../../assets/images/simustock/search.png" alt="">
  </div>
</template>

<script>
export default {
    data(){
        return{
            t:'如何报名参加比赛？',
            p1:'1.扫码或在应用商店下载爱股票APP',
            p2:'2.启动APP后，搜索“模拟炒股大赛”，点击进入活动页面，即可报名参赛',
        }
    }
}

</script>
<style lang="scss" scoped>
    @import "~@/assets/sass/global.scss";
    .wrap{
        margin-top: rem(34px);
        background: #FFFFFF;
        border-radius: rem(20px);
        padding: rem(27px) rem(40px) rem(40px);
        text-align: center;

        >h1{
            font-size: rem(32px);
            text-align: center;
            font-weight: 600;
            color: #333333;
            line-height: rem(45px);
            margin-bottom: rem(33px);
        }

        .app{
            width: rem(233px);
            margin: rem(10px) 0;
        }

        .search{
            width: rem(507px);
            margin: rem(40px) 0 0;
        }
        p{
            text-align: center;
            font-size: rem(30px);
            line-height: rem(42px);
            color: #B40707;
        }
    }
</style>